<template>
    <div id="player"></div>
</template>
<script>
export default {
    props: ['videos'],
    mounted: function() {
        var tag = document.createElement('script');
        tag.src = "https://www.youtube.com/iframe_api";
        var firstScriptTag = document.getElementsByTagName('script')[0];
        firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
        var player;
        window.onYouTubeIframeAPIReady = () => {
            player = new YT.Player('player', {
                height: 720,
                width: 1280,
                videoId: this.videos[0].Key
            });
        }
        player.loadVideoById(this.videos[0].Key);
    }
}
</script>